import { createMuiTheme, responsiveFontSizes } from '@material-ui/core';

import palette  from './palette';

const theme = responsiveFontSizes(
    createMuiTheme({
      palette,
      layout: {
        contentWidth: 1280,
      },
      typography: {
        fontFamily: 'Helvetica',
      },  flexColumnCenter: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      },
      flexRowCenter: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'
      },
      zIndex: {
        appBar: 1200,
        drawer: 1100,
      },
      overrides: {
        MuiButton: {
          containedSecondary: {
            color: 'white',
          },
        },
      },
    }),
);


export default theme;


/*

export default {
  palette: {
    primary: {
      main: '#fffff'
    }
  },
  // Enable typography v2: https://material-ui.com/style/typography/#migration-to-typography-v2
  typography: {
    useNextVariants: true
  },
  flexColumnCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  flexRowCenter: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  }
}
*/